import ScalesIcon from "@redotech/redo-icons/scales-01.svg";
import { PostPurchaseSplitStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { isDef } from "@redotech/util/checks";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as css from "./node.module.css";

export interface PostPurchaseSplitNodeData {
  step: PartialWithRequiredType<PostPurchaseSplitStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const PostPurchaseSplitNode = memo(function PostPurchaseSplitNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: PostPurchaseSplitNodeData;
  selected?: boolean | undefined;
}) {
  return isDef(data.step.name) ? (
    <BaseNode
      containerClassName={css.checkoutNode}
      icon={<RedoFeaturedIcon color="warning" Icon={ScalesIcon} size="sm" />}
      onDelete={
        data.readonly || data.step.isActive
          ? undefined
          : () => data.deleteElements(id)
      }
      selected={selected}
      step={data.step}
      title="A/B test"
    >
      <Handle id="top" position={Position.Top} type="target" />
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xxs" textColor="secondary">
          Name
        </Text>
        <Flex w="full">
          <RedoBadge color="gray" size="xs" text={data.step.name} />
        </Flex>
      </Flex>
      <Handle id="bottom" position={Position.Bottom} type="source" />
    </BaseNode>
  ) : null;
});
